/* eslint-disable */
export default function getBrowserType() {

    let type = "Unknown";
    if (process.env.VUE_ENV === 'development')
    console.log(navigator.userAgent)
    if ((navigator.userAgent.includes("Macintosh")) && (navigator.userAgent.includes("Version")) && (navigator.userAgent.includes("Safari"))) {
        type = "safari";
    } else if ((navigator.userAgent.includes("Edg")) && (navigator.userAgent.includes("Chrome"))) {
        type = "edge";
    } else if ((navigator.userAgent.includes("Opera"))) {
        type = "opera";
    } else if ((navigator.userAgent.includes("Firefox"))) {
        type = "firefox";
    } else if (navigator.userAgent.includes("Chrome")) {
        type = "chrome";
    } else {
        //
    }
    return type;
}
